// extracted by mini-css-extract-plugin
export var dataCell = "_pa-2";
export var dataRow = "_pa-0";
export var headerRow = "_pa-1";